__turbopack_context__.v({
  "events-list": "FGHndW_events-list",
  "home-wrapper": "FGHndW_home-wrapper",
  "page": "FGHndW_page",
});
